import { API_BASE_URL } from '../config';
import { adminFetch } from '../utils/adminFetch';

async function parseDeleteError(res: Response): Promise<string> {
  let message = '従業員データの削除に失敗しました。';
  try {
    const data = await res.json();
    if (data && typeof data.message === 'string' && data.message.trim()) {
      message = data.message.trim();
    }
  } catch {
    const text = await res.text().catch(() => '');
    if (text.trim()) message = text.trim();
  }
  if (res.status === 404) {
    message = '従業員が見つかりません。';
  }
  return message;
}

async function assertAdminSessionOnAuthFailure(res: Response): Promise<void> {
  if (res.status === 401) {
    window.dispatchEvent(new Event('admin-session-expired'));
    throw new Error('管理者セッションが無効です。再度ログインしてください。');
  }
  if (res.status === 403) {
    const me = await adminFetch(`${API_BASE_URL}/api/auth/admin/me`);
    if (!me.ok) {
      window.dispatchEvent(new Event('admin-session-expired'));
      throw new Error('管理者セッションが無効です。再度ログインしてください。');
    }
    throw new Error('この操作は許可されていません。CSRFトークンを更新するため、ページを再読み込みして再度お試しください。');
  }
}

/** Registration-only row (新規登録). No confirm email required. */
export async function deleteRegisteredEmployee(email: string): Promise<void> {
  const res = await adminFetch(
    `${API_BASE_URL}/api/employees/${encodeURIComponent(email.trim())}`,
    { method: 'DELETE' }
  );
  if (res.status === 204) {
    return;
  }
  await assertAdminSessionOnAuthFailure(res);
  throw new Error(await parseDeleteError(res));
}

/** Archive / onboarded employee — full data removal (confirm email required). */
export async function deleteEmployeeCompletely(email: string, confirmEmail: string): Promise<void> {
  const res = await adminFetch(
    `${API_BASE_URL}/api/employees/${encodeURIComponent(email.trim())}`,
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ confirmEmail: confirmEmail.trim() }),
    }
  );
  if (res.status === 204) {
    return;
  }
  await assertAdminSessionOnAuthFailure(res);
  throw new Error(await parseDeleteError(res));
}
